// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + ".chunk." + {"958":"f9f66370","962":"0b48918c","974":"3eab274b"}[chunkId] + ".css";
};